// FileUpload.jsx
import React, { useState } from "react";
import axios from "axios";

function FileUpload() {
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState("");

const uploadFile = async () => {
  if (!file) {
    alert("من فضلك اختر ملف للرفع");
    return;
  }

  const data = new FormData();
  data.append("file", file);
  data.append("upload_preset", "EASY-TASK");

  try {
    const res = await axios.post(
      "https://api.cloudinary.com/v1_1/dg33sas94/auto/upload",
      data
    );
    setUrl(res.data.secure_url);
  }catch (err) {
  console.error("خطأ في رفع الملف:", err.response?.data || err.message);
  alert("حدث خطأ أثناء رفع الملف. " + (err.response?.data?.error?.message || err.message));
}

};


  return (
    <div>
      <input
        type="file"
        onChange={(e) => setFile(e.target.files[0])}
        accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      />
      <button onClick={uploadFile}>رفع الملف</button>

      {url && (
        <>
          {file?.type.startsWith("image/") ? (
            <img src={url} alt="الملف المرفوع" width="200" />
          ) : (
            <a href={url} target="_blank" rel="noopener noreferrer">
              افتح الملف المرفوع
            </a>
          )}
        </>
      )}
    </div>
  );
}

export default FileUpload;
